<template>
    <v-app>
        <v-main>
            <section class="content">
                <div class="container-fluid">
                    <div class="row">
                        <div class="col-12">
                            <div class="card">
                                <div class="card-header">
                                    <h3 class="card-title">Daftar Permintaan Perubahan Harga Invoice</h3>
                                </div>
                                <div class="card-body">
                                    <div class="row">
                                        <div class="col-md-2">
                                            <div class="form-group">
                                                <v-dialog
                                                    ref="dialog"
                                                    v-model="modaltgl"
                                                    :return-value.sync="tanggal_query"
                                                    persistent
                                                    width="290px"
                                                >
                                                    <template v-slot:activator="{ on, attrs }">
                                                        <v-text-field
                                                            v-model="tanggal_query"
                                                            readonly
                                                            v-bind="attrs"
                                                            v-on="on"
                                                            label="Bulan Permintaan Perubahan" 
                                                            outlined
                                                            dense 
                                                            return-object 
                                                            class="w-100"
                                                            append-icon="mdi-calendar" 
                                                        ></v-text-field>
                                                    </template>

                                                    <v-date-picker
                                                        v-model="tanggal_query"
                                                        type="month"
                                                        scrollable
                                                        min="2022-08"
                                                        :max="dateMax"
                                                    >
                                                    <v-spacer></v-spacer>
                                                        <v-btn text color="primary" @click="modaltgl = false">
                                                            Cancel
                                                        </v-btn>
                                                        <v-btn text color="primary" @click="ubahTanggalTampil($refs)">
                                                            OK
                                                        </v-btn>
                                                    </v-date-picker>
                                                </v-dialog>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="row">
                                        <div class="col-md-12 table-responsive p-0">
                                            <table class="table table-hover">
                                                <thead>
                                                    <tr>
                                                        <th style="width: 5% !important;">No</th>
                                                        <th>No Inv</th>
                                                        <th>Nama PLG</th>
                                                        <th>Bulan Pakai</th>
                                                        <th>Tanggal Dibuat</th>
                                                        <th>Oleh</th>
                                                        <th style="text-align: end;">Total Bayar Lama</th>
                                                        <th style="text-align: end;">Total Bayar Baru</th>
                                                        <th style="text-align: center;">Keterangan</th>
                                                        <th style="text-align: center;">Status</th>
                                                        <th style="text-align: center;">Detail Approval</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <template v-if="datas.length">
                                                        <tr v-for="(row, index) in datas" :key="row.id">
                                                            <td>{{ index + 1 }}</td>
                                                            <td>{{ row.invoice_id }}</td>
                                                            <td>{{ row.detail_invoice.pelanggan_internet.nama }}</td>
                                                            <td>{{ getBulan(row.detail_invoice.bulan_pemakaian) }}</td>
                                                            <td>{{ row.created_at | indoDate }}</td>
                                                            <td>{{ row.prorate_created_by.name }}</td>
                                                            <td style="text-align: end;"><strong>{{ row.total_bayar_lama | toCurrency }}</strong></td>
                                                            <td style="text-align: end;"><strong>{{ row.total_bayar_baru | toCurrency }}</strong></td>
                                                            <td style="text-align: center;">
                                                                <button class="btn btn-xs btn-info" @click="bukaKeteranganModal(row.keterangan)" title="Lihat Keterangan">
                                                                    <i class="fas fa-eye text-white"></i>
                                                                </button>
                                                            </td>
                                                            <td style="text-align: center;">
                                                                <span class="badge badge-danger" v-if="row.statusnya.includes(2)">Ditolak</span>
                                                                <span class="badge badge-success" v-else-if="row.statusnya.every((val, i, arr) => val === arr[0] && val == 1)">Diterima</span>
                                                                <span class="badge badge-warning" v-else>Menunggu Aproval</span>
                                                            </td>
                                                            <td style="text-align: center;">
                                                                <button class="btn btn-xs btn-primary" @click="bukaDetailApprovalModal(row.pejabat_approval_prorate)" title="Lihat Detail Approval">
                                                                    <i class="fas fa-search text-white"></i>
                                                                </button>
                                                            </td>
                                                        </tr>
                                                    </template>
                                                    <tr v-else>
                                                        <td colspan="11" class="text-center">
                                                            <h6>Data Kosong</h6>
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div
                        class="modal fade"
                        id="KeteranganModal"
                        tabindex="-1"
                        role="dialog"
                        aria-labelledby="KeteranganModal"
                        aria-hidden="true"
                        data-backdrop="static"
                        data-keyboard="false"
                    >
                        <div class="modal-dialog" role="document">
                            <div class="modal-content">
                                <!-- Modal Header -->
                                <div class="modal-header">
                                    <h5 class="modal-title">Keterangan Pengeluaran</h5>
                                    <button
                                        type="button"
                                        class="close"
                                        data-dismiss="modal"
                                        aria-label="Close"
                                        @click="closeKeteranganModal"
                                    >
                                        <span aria-hidden="true">&times;</span>
                                    </button>
                                </div>

                                <!-- Modal Body -->
                                <div class="modal-body">
                                    <div class="row">
                                        <div class="col-md-12">
                                            {{ tampilKet }}
                                        </div>
                                    </div>
                                </div>

                                <!-- Modal Footer -->
                                <div class="modal-footer">
                                    <button
                                        type="button"
                                        class="btn btn-secondary"
                                        data-dismiss="modal"
                                        @click="closeKeteranganModal"
                                >
                                        Close
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div
                        class="modal fade"
                        id="DetailApprovalModal"
                        tabindex="-1"
                        role="dialog"
                        aria-labelledby="DetailApprovalModal"
                        aria-hidden="true"
                        data-backdrop="static"
                        data-keyboard="false"
                    >
                        <div class="modal-dialog modal-lg" role="document">
                            <div class="modal-content">
                                <!-- Modal Header -->
                                <div class="modal-header">
                                    <h5 class="modal-title">Detail Approval</h5>
                                    <button
                                        type="button"
                                        class="close"
                                        data-dismiss="modal"
                                        aria-label="Close"
                                        @click="closeDetailApprovalModal"
                                    >
                                        <span aria-hidden="true">&times;</span>
                                    </button>
                                </div>

                                <!-- Modal Body -->
                                <div class="modal-body">
                                    <table>
                                        <thead>
                                            <tr>
                                                <th>Nama Pejabat</th>
                                                <th style="text-align: center;">Status</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-if="tampilPejabat" v-for="(row, index) in tampilPejabat">
                                                <td>
                                                    {{ row.name }}
                                                    <div v-if="row.status == 2" class="col-12 text-red mt-1">
                                                       
                                                    </div>
                                                    <p v-if="row.status == 2" class="text-red"> <strong>ALASAN :</strong> {{ row.keterangan }}</p>
                                                </td>
                                                <td style="text-align: center;">
                                                    <span class="badge badge-danger" v-if="row.status == 2">Ditolak</span>
                                                    <span class="badge badge-success" v-else-if="row.status == 1">Diterima</span>
                                                    <span class="badge badge-warning" v-else>Menunggu Aproval</span>
                                                </td>
                                            </tr>
                                            <tr v-else>
                                                <td colspan="2" class="text-center">
                                                    <h6>Gagal mengambil data pejabat aproval</h6>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>

                                <!-- Modal Footer -->
                                <div class="modal-footer">
                                    <button
                                        type="button"
                                        class="btn btn-secondary"
                                        data-dismiss="modal"
                                        @click="closeDetailApprovalModal"
                                    >
                                        Close
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </v-main>
    </v-app>
</template>

<script>
    export default {
        data() {
            return {
                datas: [],
                adaeror: [],
                menu: false,
                tampilPejabat: '',
                tampilKet: '',
                modaltgl: false,
                dateMax: new Date().toISOString().substr(0, 7),
                tanggal_query: new Date().toISOString().substr(0, 7),
                tanggal_tampil: '',
            };
        },

        methods: {
            getStatusnya() {
                this.datas.forEach(item => {
                    item.statusnya = item.pejabat_approval_prorate.map(elm => elm.status);
                });
            },

            getBulan(tanggal) {
                const tgltemp = new Date(tanggal);
                const bulan = [
                    "Januari", "Februari", "Maret", "April", "Mei", "Juni",
                    "Juli", "Agustus", "September", "Oktober", "November", "Desember"
                ];
                return `${bulan[tgltemp.getMonth()]} ${tgltemp.getFullYear()}`;
            },

            ubahTanggalTampil(e) {
                e.dialog.save(this.tanggal_query);
                this.loadData();
            },

            bukaKeteranganModal(id) {
                this.tampilKet = id;
                $('#KeteranganModal').modal('show');
            },

            closeKeteranganModal() {
                this.tampilKet = '';
                $('#KeteranganModal').modal('hide');
            },

            bukaDetailApprovalModal(pejabat) {
                this.tampilPejabat = pejabat;
                $('#DetailApprovalModal').modal('show');
            },

            closeDetailApprovalModal() {
                this.tampilPejabat = '';
                $('#DetailApprovalModal').modal('hide');
            },

            async getResults(page = 1) {
                this.$Progress.start();
                try {
                    const { data } = await axios.get(`api/invoice/list_prorate?page=${page}`);
                    this.datas = data.data;
                } catch (error) {
                    console.error("Error fetching results:", error);
                }
                this.$Progress.finish();
            },

            async loadData() {
                if (!this.$gate.isAllowed("is_invoice")) return;

                this.kategoriBelumTerpilih = true;
                this.kantorBelumTerpilih = true;

                const tahunpaid = this.tanggal_query.substr(0, 4);
                const bulanpaid = this.tanggal_query.substr(-2, 2);

                try {
                    const { data } = await axios.get(`api/invoice/list_prorate?tahunpaid=${tahunpaid}&bulanpaid=${bulanpaid}`);
                    this.datas = data.data.length ? data.data : [];
                    this.getStatusnya();
                } catch (error) {
                    console.error("Error loading data:", error);
                }

                this.tanggal_tampil = this.getBulan(this.tanggal_query);
            },

            async deletePermintaan(id) {
                const confirmDelete = await Swal.fire({
                    title: 'Yakin untuk menghapus?',
                    text: "Hanya Permintaan yang telah ditolak atau belum mendapat respon sama sekali yang dapat dihapus.",
                    showCancelButton: true,
                    confirmButtonColor: '#d33',
                    cancelButtonColor: '#3085d6',
                    confirmButtonText: 'Ya, Hapus!'
                });

                if (!confirmDelete.isConfirmed) return;

                this.$Progress.start();
                try {
                    const formData = new FormData();
                    formData.append('datanya', JSON.stringify(id));

                    const { data } = await axios.post('api/keuangan/deletePermintaanPengeluaran', formData);
                    
                    if (data.success) {
                        await this.loadData();
                        Swal.fire('Terhapus!', 'Data Permintaan Berhasil Dihapus.', 'success');
                    } else {
                        Swal.fire("Hapus Gagal!", data.message, "warning");
                    }
                } catch (error) {
                    console.error("Error deleting request:", error);
                    Swal.fire("Hapus Gagal!", "Terjadi kesalahan saat menghapus.", "warning");
                }
                this.$Progress.finish();
            }
        },

        created() {
            this.$Progress.start();
            this.loadData();
            this.$Progress.finish();
        }
    }
</script>

<style scoped>
    /* Chrome, Safari, Edge, Opera */
    input::-webkit-outer-spin-button,
    input::-webkit-inner-spin-button {
        -webkit-appearance: none;
        margin: 0;
    }
</style>